import request from "@/utils/request";

export function uploads(params) {
  return request({
    url: "/api/questionnaire/upload",
    method: "post",
    data: params
  });
}

export function add(params) {
  return request({
    url: "/api/questionnaire/add",
    method: "post",
    data: params
  });
}

export function add0829(params) {
  return request({
    url: "/api/questionnaire/add0829",
    method: "post",
    data: params
  });
}

export function add20220922(params) {
  return request({
    url: "/api/questionnaire/add20220922",
    method: "post",
    data: params
  });
}
